import { ChainId } from '@pancakeswap/sdk'
import IDO_ABI from './abi.json'

const IDO_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x72FA0842Bd7020B347668DeB26F34fC7Fb4F8656',
  [ChainId.TESTNET]: '0x9d797c2Ac7D3A56f19e3F04Ab7935259149DBb6b',
}

export { IDO_ABI, IDO_NETWORKS }
